import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '../../models/alert.model';
import { PdaService } from '../../services/pda.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-button-informe',
  templateUrl: './button-informe.component.html',
  styleUrls: ['./button-informe.component.scss'],
})
export class ButtonInformeComponent implements OnInit {
  @Input() planSelected: any;
  @Input() loadingReport: any;
  @Input() click: boolean;

  @Output() emitData = new EventEmitter();
  loading: boolean;
  constructor(private translate: TranslateService, private _pda: PdaService) {}

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }

  generateReport() {
    // let report;
    // this.loading = true;
    // if (this.planSelected) {
    //   this._pda.getReport(this.planSelected.id).subscribe(
    //     (res) => {
    //       report = res;
    //       if (report) {
    //         saveAs(report, `${this.planSelected.nombre}.pdf`);
    //         Alert.buildSuccessAlert(
    //           this.translate.instant('action_plan.report')
    //         );
    //       }
    //       this.loading = false;
    //       console.log('REPORT', res);
    //     },
    //     (err) => {
    //       Alert.buildErrorAlert(
    //         this.translate.instant('action_plan.report_error')
    //       );
    //       this.loading = false;
    //       console.log('ERROR REPORT', err);
    //     }
    //   );
    // }
    this.emitData.emit(true);
  }
}
